import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { AgendaResponse } from 'src/app/global/interfaces/agenda-response';
import { environment } from 'src/environments/environment';
import { AgendaService } from '../../../services/agenda.service';

@Injectable()
export class AgendaProvider extends AgendaService {

    private baseUrl = _.get(environment, 'api.host', '');
    private basePath = _.get(environment, 'api.path', '');
    private baseEndpoint = _.get(environment, 'api.endpoints');
    private endpoint: string;


    constructor(private http: HttpClient) {
        super();
    }

    getAgenda(): Observable<AgendaResponse> {
        this.endpoint = this.baseUrl + this.basePath + _.get(this.baseEndpoint, 'PASO_3.AGENDA');
        // this.endpoint = 'https://run.mocky.io/v3/8b16d450-e250-4bb8-96f2-4ec99510e7fd';
        return this.http.get<AgendaResponse>(this.endpoint);
    }
    postAgenda(agenda: any): Observable<any> {
        this.endpoint = this.baseUrl + this.basePath + _.get(this.baseEndpoint, 'PASO_3.AGENDA');

        return this.http.post(this.endpoint, agenda);
    }

}
